
// 手机号码中间几位加密
export function encryptPhone(phone) {
  return phone.toString().substr(0, 3) + '****' + phone.toString().substr(7)
}